import { getExactDate } from "./getExactDate";

export function getExactMonth() {
    const date = getExactDate();
    date.setDate(1);
    return date;
}